import { Currency } from '@/constants/currency'
import { useWallets } from '@/domains/Business/hooks'

import { EURCBanner } from './EURCBanner'

type Props = {
  currency: Currency
  walletId?: string
  isPending?: boolean
}

export const SidebarNewCurrencyBanner = ({
  currency,
  walletId,
  isPending,
}: Props) => {
  const { detailsPerCurrency } = useWallets()

  const isCurrencyMainWallet =
    detailsPerCurrency?.find((detail) => detail.currency === currency)
      ?.mainWalletId === walletId

  if (!isCurrencyMainWallet || isPending) {
    return null
  }

  switch (currency) {
    case Currency.EURC:
      return <EURCBanner className="pt-4" />

    default:
      return null
  }
}
